import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PromotionAction } from 'src/app/models/promotionAction.model';
import { SebbieTask } from 'src/app/models/sebbietask.model';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { PromotionDetailDialogComponent } from '../promotion-detail-dialog/promotion-detail-dialog.component';

@Component({
  selector: 'header-content-task',
  templateUrl: './header-content-task.component.html',
  styleUrl: './header-content-task.component.scss'
})
export class HeaderContentTaskComponent {
  @Input() profile: StreApperInfo;
  @Input() currentPromotionAction: PromotionAction;
  @Input() availableTasks: Array<SebbieTask>;
  @Input() sebbiesReceived: number;

  constructor(
    private readonly dialog: MatDialog
  ) {}

  isTaskCompleted(task: SebbieTask): boolean {
    return this.profile.completedSebbieTasks?.some(
      (completedTask) => completedTask.id === task.id
    );
  }

  openPromotionDialog(): void {
    this.dialog.open<PromotionDetailDialogComponent>(PromotionDetailDialogComponent, {
      autoFocus: false, // To prevent select state of close button in header
      data: {
        promotionAction: this.currentPromotionAction,
      }
    });
  }
}
